import type { AnyRouter } from "@tanstack/react-router";

// Long-lived tabs (lab PCs left open for days) keep running whatever bundle
// they loaded. We poll /version.json, and once a newer build is deployed the
// next in-app navigation becomes a full page load instead. Navigating already
// discards the current page, so this never interrupts in-progress input.

const POLL_INTERVAL_MS = 5 * 60 * 1000;

let stale = false;

async function checkVersion(): Promise<void> {
  if (stale) return;
  try {
    const res = await fetch("/version.json", { cache: "no-store" });
    if (!res.ok) return;
    const { buildId } = (await res.json()) as { buildId?: string };
    if (buildId && buildId !== __BUILD_ID__) stale = true;
  } catch {
    // Offline or mid-deploy; try again next tick.
  }
}

export function installBuildVersionCheck(router: AnyRouter): void {
  // In dev there is no version.json; the fetch gets Vite's HTML fallback,
  // fails to parse, and the check stays a no-op.
  setInterval(checkVersion, POLL_INTERVAL_MS);
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") void checkVersion();
  });

  router.subscribe("onBeforeNavigate", ({ toLocation, hrefChanged }) => {
    if (stale && hrefChanged) window.location.assign(toLocation.href);
  });
}
